import { Controller } from "@hotwired/stimulus";
import I18n from "../../i18n.js";
import $ from "jquery";
import "daterangepicker";

// Connects to data-controller="filters--dates-range"
export default class extends Controller {
  connect() {
    $(this.element).daterangepicker({
      timePicker: true,
      timePicker24Hour: true,
      showCustomRangeLabel: false,
      opens: "left",
      locale: {
        format: "YYYY-MM-DD HH:mm:ss",
        applyLabel: I18n.t("flow_histories.index.daterangepicker.apply_label"),
        cancelLabel: I18n.t(
          "flow_histories.index.daterangepicker.cancel_label"
        ),
        daysOfWeek: [
          I18n.t("flow_histories.index.daterangepicker.su"),
          I18n.t("flow_histories.index.daterangepicker.mo"),
          I18n.t("flow_histories.index.daterangepicker.tu"),
          I18n.t("flow_histories.index.daterangepicker.we"),
          I18n.t("flow_histories.index.daterangepicker.th"),
          I18n.t("flow_histories.index.daterangepicker.fr"),
          I18n.t("flow_histories.index.daterangepicker.sa"),
        ],
        monthNames: [
          I18n.t("flow_histories.index.daterangepicker.january"),
          I18n.t("flow_histories.index.daterangepicker.february"),
          I18n.t("flow_histories.index.daterangepicker.march"),
          I18n.t("flow_histories.index.daterangepicker.april"),
          I18n.t("flow_histories.index.daterangepicker.may"),
          I18n.t("flow_histories.index.daterangepicker.june"),
          I18n.t("flow_histories.index.daterangepicker.july"),
          I18n.t("flow_histories.index.daterangepicker.august"),
          I18n.t("flow_histories.index.daterangepicker.september"),
          I18n.t("flow_histories.index.daterangepicker.october"),
          I18n.t("flow_histories.index.daterangepicker.november"),
          I18n.t("flow_histories.index.daterangepicker.december"),
        ],
      },
    });
  }
}
